import React from 'react';
import { SectionLabel } from './SectionLabel';
const facts = [{
  stat: 'Rings 4x',
  body: 'Then it goes to voicemail. Most people don’t leave one. They go back to the results page they came from.'
}, {
  stat: 'Next guy',
  body: 'The one below you on Google answers on the second ring. Same neighborhood, same job, your ad money.'
}, {
  stat: 'Paid twice',
  body: 'You paid Yelp for the lead and you paid your crew to be busy. Missing the call means you got neither.'
}];
export function Leak() {
  return <section className="border-b border-[#1a1a1a]" data-id="element-325" data-mp="3j1ec0vj8p9nz">
      <div className="mx-auto w-full max-w-6xl px-6 py-20 lg:py-28" data-id="element-326" data-mp="35baxkqqlqk93">
        <SectionLabel data-id="element-327" data-mp="358ye295741tx">The leak</SectionLabel>

        <div className="mt-8 grid grid-cols-1 gap-12 lg:grid-cols-[1fr_1fr] lg:gap-16" data-id="element-328" data-mp="3a8uannbkcqzg">
          <h2 className="text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-329" data-mp="1tsnecncx15i">
            A missed call isn&rsquo;t a missed call. It&rsquo;s a booked job walking to the next
            guy on Google.
          </h2>
          <div className="space-y-5 text-lg leading-relaxed text-neutral-400" data-id="element-330" data-mp="16coac4i2kdud">
            <p data-id="element-331" data-mp="12c4b8vdxr05l">
              You already paid for that person: ad spend, Yelp fees, years of reviews. The lead
              doesn&rsquo;t disappear when you&rsquo;re under a sink at 2pm. It just goes
              somewhere else.
            </p>
          </div>
        </div>

        <ul className="mt-14 grid grid-cols-1 gap-px overflow-hidden rounded-xl border border-[#1c1c1c] bg-[#1c1c1c] sm:grid-cols-3" data-id="element-332" data-mp="1pzma1avmayi2">
          {facts.map(f => <li key={f.stat} className="bg-[#0d0d0d] p-7" data-id="element-333" data-mp="1z13m8i5wmg1h">
              <p className="font-mono text-sm uppercase tracking-[0.15em] text-emerald-500" data-id="element-334" data-mp="1z0k2qx0lvjlc">
                {f.stat}
              </p>
              <p className="mt-3 text-sm leading-relaxed text-neutral-400" data-id="element-335" data-mp="1u062i158xdxv">{f.body}</p>
            </li>)}
        </ul>
      </div>
    </section>;
}